// extracted by mini-css-extract-plugin
module.exports = {"bryxCard":"bryxCard","cardHeader":"cardHeader","cardIcon":"cardIcon","cardContent":"cardContent"};